/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_N8n_Title_2Inputs */

const en_svc_n8n_title_2 = /** @type {(inputs: Svc_N8n_Title_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`in n8n, built to last.`)
};

const lv_svc_n8n_title_2 = /** @type {(inputs: Svc_N8n_Title_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`n8n vidē, veidota ilgtermiņam.`)
};

/**
* | output |
* | --- |
* | "in n8n, built to last." |
*
* @param {Svc_N8n_Title_2Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_n8n_title_2 = /** @type {((inputs?: Svc_N8n_Title_2Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_N8n_Title_2Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_n8n_title_2(inputs)
	return en_svc_n8n_title_2(inputs)
});